import React from "react";
import { HiCheckBadge } from "react-icons/hi2";

const Libraries = () => {
    return (
        <div className="skills__content">
            <h3 className="skills__title">Framework/Library</h3>
            <div className="skills__box">
                <div className="skills__group">
                    <div className="skills__data">
                        <HiCheckBadge />
                        <div>
                            <h3 className="skills__name">Node.js</h3>
                            {/* <span className="skills__level">Basic</span> */}
                        </div>
                    </div>
                    <div className="skills__data">
                        <HiCheckBadge />
                        <div>
                            <h3 className="skills__name">MySQL</h3>
                            {/* <span className="skills__level">Intermediate</span> */}
                        </div>
                    </div>

                    <div className="skills__data">
                        <HiCheckBadge />
                        <div>
                            <h3 className="skills__name">MongoDB</h3>
                            {/* <span className="skills__level">Intermediate</span> */}
                        </div>
                    </div>
                    <div className="skills__data">
                        <HiCheckBadge />
                        <div>
                            <h3 className="skills__name">JavaScript</h3>
                            {/* <span className="skills__level">Intermediate</span> */}
                        </div>
                    </div>
                  
                    <div className="skills__data">
                        <HiCheckBadge />
                        <div>
                            <h3 className="skills__name">ChakraUI</h3>
                            {/* <span className="skills__level">Intermediate</span> */}
                        </div>
                    </div>
                    <div className="skills__data">
                        <HiCheckBadge />
                        <div>
                            <h3 className="skills__name">Redux</h3>
                            {/* <span className="skills__level">Intermediate</span> */}
                        </div>
                    </div>
                    
                </div>
                <div className="skills__group">
                <div className="skills__data">
                        <HiCheckBadge />
                        <div>
                            <h3 className="skills__name">Express</h3>
                            {/* <span className="skills__level">Intermediate</span> */}
                        </div>
                    </div>
            
                    <div className="skills__data">
                        <HiCheckBadge />
                        <div>
                            <h3 className="skills__name">Sequelize</h3>
                            {/* <span className="skills__level">Intermediate</span> */}
                        </div>
                    </div>
                    <div className="skills__data">
                        <HiCheckBadge />
                        <div>
                            <h3 className="skills__name">Mongoose</h3>
                            {/* <span className="skills__level">Intermediate</span> */}
                        </div>
                    </div>
                   
                    <div className="skills__data">
                        <HiCheckBadge />
                        <div>
                            <h3 className="skills__name">Typescript</h3>
                            {/* <span className="skills__level">Basic</span> */}
                        </div>
                    </div>
                    <div className="skills__data">
                        <HiCheckBadge />
                        <div>
                            <h3 className="skills__name">React</h3>
                            {/* <span className="skills__level">Basic</span> */}
                        </div>
                    </div>
                    <div className="skills__data">
                        <HiCheckBadge />
                        <div>
                            <h3 className="skills__name">RTK</h3>
                            {/* <span className="skills__level">Basic</span> */}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Libraries;